import { ProductType } from "../../../commons/specs/product";
import { IconSource } from "../../../commons/types/icon";
import * as icons from "../../../resources/icons";

export const getFilterGroupIcon = (productType: ProductType, groupKey: string): IconSource => {
  if (productType === ProductType.Bicycle) {
    switch (groupKey) {
      case "frame":
        return icons.IconSmallBicycleFrame;
      case "gear":
        return icons.IconSmallBicycleCassette;
      case "specifications":
        return icons.IconSmallBatteryStanding;
      case "general":
        return icons.IconSmallTag;
      default:
        break;
    }
  }

  return icons.IconSmallAsterisk;
};
